<template>

  <div class="live-wrapper">
    <van-list v-if="list.length"  v-model="loading" :finished="finished" :immediate-check="immediate" :finished-text="finishedTxt" @load="moreList">
      <div class="job-zt-list-1">
        <div class="item-box" v-for="(item,index) in list" :key="index">
          <div class="item" @click="goDes(item)">
            <!--            <router-link>-->
            <img alt="" v-lazy="item.cover" />
            <div class="top-box justify-align">
              <div>
                <div class="top-lf content-center" :style="{padding: (item.live_status == 0?'0':'')}">
                  <template v-if="item.live_status==1">
                    <!--                      <img src="../../assets/zhiboz_icon.png" alt="" />-->
                    <div class="ele-box">
                      <span class="ele"></span>
                      <span class="ele"></span>
                      <span class="ele"></span>
                    </div>
                    <span>直播中</span>
                  </template>
                  <template v-else-if="item.live_status==2">
                    <img :src="require('../../assets/'+appTheme+'/zhibo_huo.png')" alt="" />
                    <span>热播</span>
                  </template>
                  <template v-else-if="item.live_status==3">
                    <img :src="require('../../assets/'+appTheme+'/zhibo_huo.png')" alt="" />
                    <span>热搜</span>
                  </template>
                  <template v-else-if="item.live_status==4">
                    <img :src="require('../../assets/'+appTheme+'/zhibo_huo.png')" alt="" />
                    <span>首发</span>
                  </template>
                  <template v-else-if="item.live_status==5">
                    <img :src="require('../../assets/'+appTheme+'/vip_icon.png')" alt="" />
                    <span>VIP</span>
                  </template>
                  <template v-else-if="item.live_status==6">
                    <img :src="require('../../assets/'+appTheme+'/zhibo_vr.png')" alt="" />
                    <span>VR</span>
                  </template>
                </div>
              </div>

              <!--                <div class="top-rt left-justifying"><div class="xin-icon-box"><img src="../../assets/xin_zhibo.png" alt="" /></div>{{item.likes}}</div>-->

            </div>
            <div class="time-box" v-if="item.live_type== 'live'&& countDownList[index].finish==false">
              <div class="left-justifying">
                <van-icon size="20" name="clock-o" />
                <!--                <div style='color:#FF0002;margin-left:1.33333vw;' v-if="countDownList[index].finish">结束-->
                <!--                </div>-->
                <div style='margin-left:1.33333vw;'>
                  <span class='countDownList'>{{countDownList[index].day}}</span> 天
                  <span class='countDownList'>{{countDownList[index].hou}}</span> 时
                  <span class='countDownList'>{{countDownList[index].min}}</span> 分
                  <!--                  <span class='countDownList'>{{countDownList[index].sec}}</span> 秒-->
                  <span>后开播</span>
                </div>
              </div>
            </div>
            <div class="title-box">
              <div class="justify-align">
                <div class="zan-box left-justifying">
                  <div v-for="(icon,i) in item.items" :key="i">
                    <img v-if="icon=='hongbao'" :src="require('../../assets/'+appTheme+'/zhibo1.png')" alt="" />
                    <img v-if="icon=='bonus'" :src="require('../../assets/'+appTheme+'/zhibo2.png')" alt="" />
                    <img v-if="icon=='onepay'" :src="require('../../assets/'+appTheme+'/zhibo3.png')" alt="" />
                    <img v-if="icon=='daka'" :src="require('../../assets/'+appTheme+'/zhibo4.png')" alt="" />
                    <img v-if="icon=='star'" :src="require('../../assets/'+appTheme+'/zhibo6.png')" alt="" />
                    <img v-if="icon=='gift'" :src="require('../../assets/'+appTheme+'/zhibo5.png')" alt="" />
                  </div>

                </div>
                <div class="top-rt left-justifying"><div class="xin-icon-box"><img class="top-rt-img" :src="require('../../assets/'+appTheme+'/xin_zhibo.png')" alt="" /></div>{{item.likes}}</div>

              </div>

              <div class="title-txt">{{item.title}}</div>
            </div>
            <!--            </router-link>-->
          </div>
        </div>
      </div>
    </van-list>
    <div class="null-box" style="padding-bottom: 2.66667vw;"></div>
    <!--    <div class="tab-bar-box">-->
    <!--      <div class="tab-bar-box-content">-->
    <!--        <div class="tab-item content-center" @click="goHome">-->
    <!--          <img src="../../assets/f_home.png" alt="" />首页-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import { getListData } from '@/api/zhibo'
export default {
  name: "zhiBoList",
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      list: [],
      cover_img: require('@/assets/live-img.jpg'),
      loading: false, // 加载状态
      finished: false, // 是否加载
      page: 1,
      currentPage: 1,
      immediate: false,
      finishedTxt: '没有更多了~',
      statusType: 'null',
      actEndTimeList: [],// 提取出来的倒计时数组列表
      countDownList: [], // 显示倒计时
      timer:null
    }
  },
  beforeCreate() {		//在页面创建之前设置body的背景色
    // console.log('创建')
    document.querySelector('body').setAttribute('style', 'background: #fff;')
  },
  beforeDestroy() {		//在页面销毁之前移除body的属性，目的是设置的颜色只对当前页面有效
    // document.querySelector('body').removeAttribute('style')
  },
  // 列表页面
  activated() {
    if (!this.$route.meta.isBack) { // false
      // console.log('isBack',this.$route.meta.isBack)
      //isBack 时添加中router中的元信息，判读是否要缓存
      this.resetQuery(); //清空原有数据
      this.getList(); // 重新加载
      if (this.$route.query.name){
        window.document.title = this.$route.query.name // res.data.desc
        this.$route.meta.title= this.$route.query.name
      }
    } else { // 要缓存
      // console.log('22isBack',this.$route.meta.isBack)
      // 执行倒计时函数
      this.countDown();
    }
    this.$route.meta.isBack = false; // 通过这个控制刷新，否则会一直为true
    document.querySelector('body').setAttribute('style', 'background: #fff;')
  },

  beforeRouteLeave(to, from, next) { // 列表页面跳转到 详情页时，设置需要缓存 to: 即将要进入的目标 用一种标准化的方式 //from: 当前导航正要离开的路由 用一种标准化的方式
    // 去除背景色
    // console.log('离开界面')
    document.querySelector('body').setAttribute('style', '')
    if (to.path == '/zhiBoDes' || to.path == '/liveDes2') {
      //当离开的时候不是去首页的时候开启缓存
      from.meta.isBack = true;
      // console.log('meta',from.meta)
    }else {
      from.meta.isBack = false;
    }
    next()
  },
  created() {
    // this.getList()
    this.$store.commit("setLiveItem",'')
  },
  //生命周期 destroyed销毁定时器
  destroyed(){
    // console.log('销毁')
    clearTimeout(this.timer);
    // clearInterval(this.timer)
    this.timer = null;
  },
  methods:{
    resetQuery(){ //清空原有数据
      this.list = []
      this.loading = false // 加载状态
      this.finished= false // 是否加载
      this.page = 1
      this.currentPage = 1,
      this.immediate = false
      this.statusType = 'null'
        this.actEndTimeList = [] // 提取出来的倒计时数组列表
        this.countDownList = []  // 显示倒计时
        this.timer = null
    },
    goHome(){
      this.$router.push('/');
    },
    goDes(item){
      console.log(item.href)
      // this.$router.push({path:'/liveDes2',query: {item:item}})
      if (item.live_type=='live'){ // 直播
        if (item.href != null){
          window.open(item.href)
        } else {
          // 获取设备信息并判断是否是ios
          // let u = navigator.userAgent;
          // let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
          // if (isiOS) {
          //   // ios系统就拼接随机字符串
          //   var url = 'https://jpzs-zst.itos.cn/zhiBoDes?id='+item.id
          //     window.open(url)
          // } else {
          //   this.$router.push({path:'/zhiBoDes',query: {id:item.id}})
          // }
          this.$router.push({path:'/zhiBoDes',query: {id:item.id}})
        }
        // window.open(item.href)
        // this.$router.push({path:'/zhiBoDes',query: {id:item.id}})
      } else { // 重播
        this.$router.push({path:'/liveDes2',query: {id:item.id}})
        // this.$router.push({path:'/liveDes',query: {id:item.id}})
      }

    },
    getList(){
      var that = this
      var data = {
        page:1
      }
      getListData(data).then(res => {
        if(res.code == 200)
        {
          this.loading = true; // 防止多次触发load事件
          // console.log('res',res.data.data)
          that.list = res.data.data
          let endTimeList = [];
        //定义一个新数组，将活动的结束时间参数提成一个单独的数组
          for(let i=0;i< that.list .length;i++){
            var objs = {};
            objs.eTime = that.list [i].live_time
            objs.finish = false
            endTimeList .push(objs)
          }
          that.actEndTimeList =  endTimeList
          // 执行倒计时函数
          this.countDown();

          // 加载状态结束
          this.loading = false;
          if (res.data.data.length == res.data.total){ // 数据全部加载完
            that.finished = true; // 数据全部加载完
            if(res.data.data.length == 0){
              this.finishedTxt = '暂无数据~'
            } else {
              this.finishedTxt = '没有更多了~'
            }
          }else {
            that.finished = false; // 可以加载
          }
        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
    moreList(){
      var that = this
      this.currentPage += 1;//页数+1
      var data = {
        page:this.currentPage
      }
      getListData(data).then(res => {
        if(res.code == 200)
        {
          this.loading = true;
          var arr = this.list.concat(res.data.data);
          that.list = arr
          // console.log(that.list.length)
          let endTimeList = [];
          //定义一个新数组，将活动的结束时间参数提成一个单独的数组
          for(let i=0;i< that.list .length;i++){
            var objs = {};
            objs.eTime =String(that.list[i].live_time).replace(/\-/g, '/')
            objs.finish = false
            endTimeList .push(objs)

          }
          // console.log(999)
          that.actEndTimeList =  endTimeList
          // console.log('en',that.actEndTimeList)
          // 执行倒计时函数
          this.countDown();
          // 加载状态结束
          this.loading = false;
          // console.log(res.data.data.length)
          if (that.list.length == res.data.total) { // 数据全部加载完成
            this.finished = true; // 防止多次触发load事件
            console.log('加载完毕')
          } else {
            this.finished = false;
          }
        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
    //小于10的格式化函数
    timeFormat(times) {
      return times< 10 ? '0' + times: times;
    },
    //倒计时函数
    countDown() {
      let that = this
      // 获取当前时间，同时得到活动结束时间数组
      let newTime = new Date().getTime();
      let endTimeList = this.actEndTimeList;

      let countDownArr = [];

      // 对结束时间进行处理渲染到页面
      endTimeList.forEach(o => {

        let endTime = new Date(o.eTime ).getTime();
        let obj = null;
        // 如果活动未结束，对时间进行处理
        if (endTime - newTime > 0) {
          let time = (endTime - newTime) / 1000;
          // 获取天、时、分、秒
          let day = parseInt(time / (60 * 60 * 24));
          let hou = parseInt(time % (60 * 60 * 24) / 3600);
          let min = parseInt(time % (60 * 60 * 24) % 3600 / 60);
          let sec = parseInt(time % (60 * 60 * 24) % 3600 % 60);
          obj = {
            day: this.timeFormat(day),
            hou: this.timeFormat(hou),
            min: this.timeFormat(min),
            sec: this.timeFormat(sec),
            finish: false
          }
        } else { //活动已结束，全部设置为'00'

          obj = {
            day: '00',
            hou: '00',
            min: '00',
            sec: '00',
            finish: true
          }
        }
        countDownArr.push(obj);
      })
      // 渲染，然后每隔一秒执行一次倒计时函数
      this.countDownList = countDownArr
      // this.timer = setInterval(() => {
      //   console.log('daojishi')
      //   that.countDown
      // },1000)
      this.timer = setTimeout(() => { // - 在指定时间后执行代码
        // console.log('daojishi')
        that.countDown
      },1000)
      // setTimeout(this.countDown, 1000);
    },
  }
}
</script>

<style lang="scss" scoped>
.tab-bar-box{
  position: fixed;left: 0;bottom: 0;
  width: 100%;
  padding: 40px 0;color: #FFFFFF;font-size: 32px;
  //background: #0F0F0F;
  .tab-bar-box-content{
    .tab-item{
      //width: 50%;
      img{
        width: 52px;height: auto;display: inline-block;margin-right: 15px;
      }
    }
  }
}
.job-zt-list-1 {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-align: center;
  align-items: center;
  padding: 1px;
  .item-box {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    text-align: center;
    .item{
      position: relative;
      //width: 100%;
      overflow: hidden;
      margin: 15px 20px 15px 0;
      //height: 512px;

      //width: 342px;
      height: 540px;
      border-radius: 20px;
      a{
        display: block;
      }
      img {
        width: 100%;display: block; height: 540px; border-radius: 20px;
      }
      .title-box{
        //padding-top: 20px;
        background: linear-gradient(transparent,#000);
        width: 100%;
        position: absolute;
        right: 0;
        bottom: 0;
        color: #fff;
        .zan-box{
          text-align: left;
          padding-left: 15px;
          position: relative;
          //justify-content: flex-end;
          //align-items: self-end;
          img{
            width: 38px;
            height: auto;display: inline-block;margin-right: 5px;
          }
        }
        .title-txt{
          overflow: hidden;
          padding: 5px 15px 5px;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: left;font-size: 28px;
        }
      }
      .top-box{
        position: absolute;top:20px;width: 100%;left: 0;color: #FFFFFF;font-size: 20px;
        img{
          width: 32px;height: auto;display: inline-block;margin-right: 5px;
        }
        .top-lf{
          max-width: 110px;
          padding: 5px 20px 5px 5px;
          background: #F03926;
          border-radius: 20px;margin-left: 10px;
        }

      }
      .time-box{
        position: absolute;top:80px;width:85%;left: 10px;
        padding: 5px 10px;
        background: rgba(0, 0, 0, 0.5);font-size: 20px;
        border-radius: 80px;color: #FFFFFF;
      }
    }
  }
  .item-box:nth-child(odd) .item{
    margin-left: 15px;
  }
}
.countDownList{
  color: #fff;font-size: 24px;
}
.top-rt{
  padding: 5px 10px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 80px;margin-right: 10px;
  .xin-icon-box{
    padding: 5px 8px;
    background: #F23926;margin-right: 5px;
    opacity: 0.99;
    border-radius: 50px;
    .top-rt-img{
      width: 18px !important;
      height: 16px !important;
    }
  }
}
.ele-box{
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: row;
  width: 24px;
  height: 22px;
  border-radius: 100px;
  padding: 4px 8px;
  margin-right: 4px;
  border-top-right-radius: 20px;
  .ele{
    height: 100%;
    width: 5px;
    border-radius: 4px;
    background-color: #fff;
    display: inline-block;
    &:nth-child(1) {
      animation: liveAnimation 1.5s linear 0.3s infinite;
    }

    &:nth-child(2) {
      animation: liveAnimation 1.5s linear 0.5s infinite;
    }

    &:nth-child(3) {
      animation: liveAnimation 1.5s linear 0.1s infinite;
    }
  }

}
@keyframes liveAnimation {
  0% {
    height: 0%;
  }

  50% {
    height: 100%;
  }

  100% {
    height: 0%;
  }
}
</style>
